import React from 'react';
import classNames from 'classnames';

import css from './MaterialSymbol.module.css';

const MaterialSymbol = (props) => {
  const { symbol, className = '', style = {} } = props;
  const classes = classNames(css.root, className);

  return (
    <span className={classes} style={style}>
      {symbol}
    </span>
  );
};

export default MaterialSymbol;
